import axios from "utils/APIv2";

export const register = (postData) => {
  const res = axios.post(`/register`, postData);
  return res;
};

export const getPoolDetails = async (email, type) => {
  const params = {
    email: email,
    customer: type === "customer" ? "true" : undefined,
  };
  const res = await axios.get(`/pool-details`, { params: params });
  return res.data;
};
export const saveTokendata = async (token, username) => {
  const data = {
    token: token,
    username: username,
  };

  const res = await axios.post(`/save-token`, data);
  return res.data;
};

export const customersignup = (postData) => {
  const res = axios.post(`/customer/create`, postData);
  return res;
};

export const customerResetTempPass = (postData) => {
  const res = axios.post(`/customer/resend-temp-pass`, postData);
  return res;
};

export const customerForgotPassMethod = async(data)=>{
  const res = await axios.post('customer/forgot-password-method',data)
  return res.data
}
export const isUserConfiremd = async (payload)=>{
  const res = await axios.post('customer/is-customer-confirmed',payload)
  return res.data
}

export const switchTenant = async (email, tenantName) => {
  const data = {
    email,
    tenantName
  };
  const res = await axios.post(`/switch-tenant`, data);
  return res.data;
};

export const customerSwitchTenant = async (tenantName) => {
  const userId =
    sessionStorage.getItem("username") || sessionStorage.getItem("userId");
  const res = await axios.post(`/customers/switch-active-tenant`, {
    tenantName,
    userId,
    username: userId,
  });
  return res.data;
};